import Vue from 'vue'
import Axios from 'axios'
import Store from './vuex/store'
import Router from './router'

const configUrl = process.env.VUE_APP_ENDPOINT + process.env.VUE_APP_CONFIG_API

export default {
    configUrl: configUrl,
    endpoint: '',
    endpoints: {},

    sendNotification: function(error)
    {
        let callback = function() {
            return window.console.log('Nessuna azione prevista')
        }

        window.console.log(error.response)

        if(error.response.status != 200 && error.response.status != 511){

          if(this.$gtm) this.$gtm.trackEvent({
            event: 'customEvent',
            category: 'system',
            action: 'error',
            label: 'http_' + error.response.status,
            value: 1,
          })
          
          if(window.LogRocket) window.LogRocket.track('errorHttp_' + error.response.status)
          
        } 
        
        
        switch (error.response.status) {

            // aggiornare affiliateReferenceId
            case 300:
                // gestito a livello di componente sidebar-checkout.vue
                // TODO (michele) return error.response (e correggere su sidebar-checkout.vue) 
                return;

            // errore "pilotabile" da backend
            // posso mostrare la sola modal, gestire un redirect o un'azione
            case 303:
            case 202:

              if(error.response.data.action){

                switch(error.response.data.action){
                  case 'logout':
                    Store.commit({
                        type: 'setIntegration',
                        value: {},
                    })
                    window.location.href = '/'
                  /*
                    Store.replaceState({})
                    //Vue.prototype.$config.token = ''
                    //Vue.prototype.$config.integration.availability = 0
                    //Store.state.integration.availability = 0
                    Vue.prototype.$config.integration = {}
                    Store.state.integration = {}
                    this.mixinSendMutation('setIntegration',{})
                    setTimeout(function(){
                        window.console.log('LOGOUT')
                    },2000)
                    //Store.state.token = ''
                    //window.location.href = '/'
                    */
                    break;

                  default:
                }

              }


              if(error.response.data.updateAvailabilityTo){
                Store.commit({
                  type: 'setAvailability',
                  value: error.response.data.updateAvailabilityTo,
                })
              }


              // by route name
              if(error.response.data.routerPush){
                callback = function() {
                  Router.push({name: error.response.data.routerPush})
                }
              }


              // by path
              if(error.response.data.routerPushPath){
                callback = function() {
                  Router.push(error.response.data.routerPushPath)
                }
              }


              // static error
              if(error.response.data.routerPushError){
                callback = function() {
                  Router.push({name: 'error', query: {error: btoa(error.response.data.routerPushError)}})
                }
              }


              // redirect
              if(error.response.data.redirectTo){
                callback = function() {
                  window.location.href = error.response.data.redirectTo
                }
              }

              break;

            // maintenance mode
            case 307:
            case 503:
                Store.replaceState({})
                Vue.prototype.$config.integration = {}
                return Router.push({name: 'maintenance'})
                /*
                callback = function() {
                    Router.push({name: 'maintenance'})
                }
                break;
                */

            // token non valido / sessione scaduta rimandare a pagina come funziona
            case 401:
                Store.replaceState({})
                Vue.prototype.$config.integration = {}
                callback = function() {
                    Router.push({name: 'how-it-works'})
                }
                break;

            // il prezzo è cambiato, rimandare a dettaglio
            case 409:
                callback = function() {
                    //Router.go(-1)//push({name: 'search'})
                    Router.back()
                }
                break;

                    
            case 501:
              callback = function() {
                  Router.push({name: 'search'})
              }
              break;
              
              
            // errore silente (es. reviews)
            // logga in console ma non segnala nulla all'utente
            case 511:
              window.console.log('http 511 errore silente')
              window.console.log(error.response)
              return false
              //break;

            case 500: // recuperabile
            case 400: // recuperabile
            case 404: // recuperabile
            case 555: // response vuota

              if(error.response.data.redirectTo){
                callback = function() {
                  window.location.href = error.response.data.redirectTo
                }
              }

              break;

            default:
              break;
        }


        let data = {
            msg: error.response.data.msg,
            status: error.response.status,
            callback: callback
        }

        if(error.response.data.title) data.title = error.response.data.title
        if(error.response.data.closeText) data.closeText = error.response.data.closeText

        window.eventBus.$emit('gotNotification',data)
        return false
    },

    getNotification: function(queryParameters)//test http errors
    {
        let params = JSON.stringify({
            testHttpStatusCode: queryParameters.httpCode
        })
        return Axios.post(this.endpoints.preview, params)
        .then(() => {
            return 'No errors!';
        }, (error) => {
            return this.sendNotification(error)
        })
    },   

    getConfig: function(queryParameters)
    {
        let _this = this

        queryParameters.token = Store.state.token

        let params = JSON.stringify(queryParameters)

        return Axios.post(this.configUrl, params)
        .then((response) => {
            _this.endpoint = response.data.endpoint
            _this.endpoints = response.data.endpoints
            return response.data;
        }, (error) => {
            return this.sendNotification(error)
        })
    },

    newsletterSubscribe: function(queryParameters)
    {
      queryParameters.token = Store.state.token
      let params = JSON.stringify(queryParameters)
      return Axios.post(this.endpoints.newsletterSubscribe, params)
        .then((response) => {
            return response.data
        }, (error) => {
            window.console.log('newsletterSubscribe error')
            window.console.log(error)
        })
    },
    
    formsSubmitter: function(queryParameters)
    {
      queryParameters.token = Store.state.token
      let params = JSON.stringify(queryParameters)
      return Axios.post(process.env.VUE_APP_FORMS_SUBMITTER_ENDPOINT, params)
        .then((response) => {
            return response.data
        }, (error) => {
            window.console.log('formsSubmitter error')
            window.console.log(error)
        })
    },

    getPosts: function(queryParameters)
    {
      let params = JSON.stringify(queryParameters)
      return Axios.post(process.env.VUE_APP_ENDPOINT_BLOG_POSTS, params)
        .then((response) => {
          // inverto l'ordine e trasformo in un array per compensare l'ordinamento interno di js quando viene parsato un oggetto con dentro altri oggetti
          let postKeys = Object.keys(response.data.posts).reverse()
          let postArray = []
          postKeys.forEach(key => {
            postArray.push(response.data.posts[key])
          })
          response.data.posts = postArray
          return response.data;
        }, (error) => {
          window.console.log('getPosts error')
          window.console.log(error)
          //return this.sendNotification(error)
        })
    },

    getTags: function(queryParameters)
    {
        queryParameters.token = Store.state.token
        let params = JSON.stringify(queryParameters)
        return Axios.post(process.env.VUE_APP_ENDPOINT_BLOG_TAGS, params)
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('getTags error')
            window.console.log(error)
            return this.sendNotification(error)
        })
    },

}